const REFRESH_KEY = "toss_ads.refresh_token";
const REMEMBER_EMAIL_KEY = "toss_ads.remember_email";

export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH_KEY);
  } catch {
    return null;
  }
}

export function setRefreshToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(REFRESH_KEY, token);
    else localStorage.removeItem(REFRESH_KEY);
  } catch {
    /* storage 비활성/quota 초과는 무시 — refresh 만 못 함 */
  }
}

export function clearRefreshToken(): void {
  setRefreshToken(null);
}

export function getRememberedEmail(): string | null {
  try {
    return localStorage.getItem(REMEMBER_EMAIL_KEY);
  } catch {
    return null;
  }
}

export function setRememberedEmail(email: string | null): void {
  try {
    if (email) localStorage.setItem(REMEMBER_EMAIL_KEY, email);
    else localStorage.removeItem(REMEMBER_EMAIL_KEY);
  } catch {
    /* ignore */
  }
}
